import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ODIconsGallery } from './ODIconsGallery';
export var ODGalleryRoot = function () {
    var match = useRouteMatch();
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: match.url + "/icon", component: ODIconsGallery }),
        React.createElement(Redirect, { to: match.url + "/icon" })));
};
//# sourceMappingURL=ODGalleryRoot.js.map